import { useForm, Controller } from 'react-hook-form';
import CONFIG from '../../constanta/config';
import axios from 'axios';
import { useEffect, useState } from 'react';
import InputText from '../../components/input/input-text';
import InputEmail from '../../components/input/input-email';
import InputTextarea from '../../components/input/input-textarea';
import InputSelect from '../../components/input/input-select';
import InputSignature from '../../components/input/input-signature';
import Header from '../../components/input/header';
import InputJam from '../../components/input/input-jam';

const PageLogin = () => {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    resetField,
    formState: { errors }
  } = useForm();

  const kehadiran = watch('kehadiran');
  const transportasi = watch('transportasi');

  useEffect(() => {
    if (transportasi === 'PESAWAT') {
      // reset field KERETA
      resetField('jam_berangkat_kereta');
      resetField('stasiun_berangkat');
      resetField('jam_pulang_kereta');
      resetField('stasiun_pulang');
    }

    if (transportasi === 'KERETA') {
      // reset field PESAWAT
      resetField('maskapai_berangkat');
      resetField('jam_berangkat');
      resetField('bandara_berangkat');
      resetField('maskapai_pulang');
      resetField('jam_pulang');
      resetField('bandara_pulang');
    }
  }, [transportasi]);

  useEffect(() => {
    resetField('transportasi');
    resetField('tiket');
  }, [kehadiran]);

  const kehadiranOptions = [
    { value: 'Hadir', label: 'Hadir' },
    { value: 'Tidak', label: 'Tidak' }
  ];

  const tiketOptions = [
    { value: 'Sudah', label: 'Sudah' },
    { value: 'Belum', label: 'Belum' }
  ];

  const transportOptions = [
    { value: 'DARAT', label: 'Darat' },
    { value: 'PESAWAT', label: 'Pesawat' },
    { value: 'KERETA', label: 'Kereta' }
  ];

  const provinces = [
    'Aceh',
    'Sumatera Utara',
    'Sumatera Barat',
    'Riau',
    'Kepulauan Riau',
    'Jambi',
    'Sumatera Selatan',
    'Bangka Belitung',
    'Bengkulu',
    'Lampung',
    'Banten',
    'DKI Jakarta',
    'Jawa Barat',
    'Jawa Tengah',
    'DI Yogyakarta',
    'Jawa Timur',
    'Kalimantan Barat',
    'Kalimantan Timur',
    'Kalimantan Selatan',
    'Kalimantan Tengah',
    'Kalimantan Utara',
    'Bali',
    'Nusa Tenggara Barat',
    'Nusa Tenggara Timur',
    'Gorontalo',
    'Sulawesi Barat',
    'Sulawesi Selatan',
    'Sulawesi Tengah',
    'Sulawesi Tenggara',
    'Sulawesi Utara',
    'Maluku',
    'Maluku Utara',
    'Papua',
    'Papua Barat',
    'Papua Barat Daya',
    'Papua Pegunungan',
    'Papua Selatan',
    'Papua Tengah'
  ];

  const instansiList = [
    'Setjen/Pusat/Biro',
    'Ditjen GTK PG',
    'Ditjen PAUD Dasmen',
    'Ditjen Vokasi',
    'BSKAP',
    'Badan Bahasa',
    'Balai Bahasa/Kantor Bahasa',
    'BGTK/BBGTK',
    'BPMP/BBPMP',
    'Dinas Pendidikan Provinsi',
    'Balai Tekkomdik/BTIKP',
    'Dinas Pendidikan Kab/Kota',
    'Satuan Pendidikan (Kepala Sekolah dan Operator)',
    'Guru Pejuang Pendidikan',
    'Hackathon Rumah Pendidikan 2025'
  ];

  const pangkatList = [
    'Penata Muda, III/a',
    'Penata Muda Tk. I, III/b',
    'Penata, III/c',
    'Penata Tk. I, III/d',
    'Pembina, IV/a',
    'Pembina Tk. I, IV/b',
    'Pembina Utama Muda, IV/c',
    'Pembina Utama Madya, IV/d',
    'Pembina Utama, IV/e',
    'Lainnya'
  ];

  const submitForm = (data) => {
    setMsg('');
    setLoading(true);

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key !== 'signature') formData.append(key, data[key]);
    });

    if (data.signature) {
      const blob = dataURLtoBlob(data.signature);
      formData.append('signature', blob, 'signature.png');
    }

    axios
      .post(CONFIG.URL_DISDUK + '/submit?t=' + Date.now(), formData, {
        responseType: 'text'
      })
      .then((res) => {
        if (res.data.toLowerCase().includes('berhasil')) {
          setShowSuccess(true);
        } else {
          setMsg(res.data);
        }
      })
      .catch(() => setMsg('Terjadi kesalahan!'))
      .finally(() => setLoading(false));
  };

  function dataURLtoBlob(dataURL) {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new Blob([u8arr], { type: mime });
  }

  return (
    <>
      {showSuccess && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg text-center w-[90%] max-w-sm">
            <p className="text-lg font-semibold mb-4">
              Terima kasih sudah mendaftar 🙏
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition">
              OK
            </button>
          </div>
        </div>
      )}

      <div className="min-h-screen w-full flex justify-center px-3 py-8">
        <div className="bg-white w-full max-w-3xl shadow-md rounded-xl p-5">
          <Header />
          <form onSubmit={handleSubmit(submitForm)} className="space-y-4">
            {/* ====================== */}
            {/* FORM DATA UTAMA        */}
            {/* ====================== */}

            <InputSelect
              label="Asal Instansi"
              name="asal_instansi"
              control={control}
              options={instansiList.map((i) => ({ value: i, label: i }))}
              error={errors.asal_instansi}
              required
            />
            <InputSelect
              label="Asal Provinsi"
              name="asal_provinsi"
              control={control}
              options={provinces.map((p) => ({ value: p, label: p }))}
              error={errors.asal_provinsi}
              required
            />

            <InputText
              label="Nama Lengkap"
              name="nama_lengkap"
              register={register}
              error={errors.nama_lengkap}
              required
            />
            <InputText
              label="NIP (jika tidak memiliki NIP di isi dengan 000)"
              name="nip"
              register={register}
              error={errors.nip}
              required
            />
            <InputText
              label="Jabatan"
              name="jabatan"
              register={register}
              error={errors.jabatan}
              required
            />
            <InputSelect
              label="Pangkat & Golongan"
              name="pangkat"
              control={control}
              options={pangkatList.map((p) => ({ value: p, label: p }))}
              error={errors.pangkat}
              required
            />
            <InputText
              label="NPWP"
              name="npwp"
              register={register}
              error={errors.npwp}
              required
            />

            {/* Jenis Kelamin */}
            <div>
              <label>
                Jenis Kelamin <span className="text-red-500">*</span>
              </label>
              <div className="flex gap-4 mt-1">
                <label>
                  <input
                    type="radio"
                    value="Laki-laki"
                    {...register('jenis_kelamin', {
                      required: 'Jenis kelamin wajib dipilih'
                    })}
                  />{' '}
                  Laki-laki
                </label>
                <label>
                  <input
                    type="radio"
                    value="Perempuan"
                    {...register('jenis_kelamin', {
                      required: 'Jenis kelamin wajib dipilih'
                    })}
                  />{' '}
                  Perempuan
                </label>
              </div>
              {errors.jenis_kelamin && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.jenis_kelamin.message}
                </p>
              )}
            </div>

            <InputTextarea
              label="Nama Unit Kerja"
              name="nama_unit_kerja"
              register={register}
              error={errors.nama_unit_kerja}
              required
            />
            <InputTextarea
              label="Alamat Unit Kerja"
              name="alamat_unit_kerja"
              register={register}
              error={errors.alamat_unit_kerja}
              required
            />
            <InputEmail
              label="Email Pribadi"
              name="email"
              setValue={setValue}
              register={register}
              error={errors.email}
              required
            />
            <InputText
              label="Nomor Telepon Seluler"
              name="telepon"
              register={register}
              error={errors.telepon}
              required
            />

            {/* ====================== */}
            {/* KONFIRMASI KEHADIRAN  */}
            {/* ====================== */}

            <InputSelect
              label="Konfirmasi Kehadiran"
              name="kehadiran"
              options={kehadiranOptions}
              control={control}
              error={errors.kehadiran}
              required
            />

            {/* ====================== */}
            {/* JIKA HADIR → PILIH TRANSPORT */}
            {/* ====================== */}

            {kehadiran === 'Hadir' && (
              <>
                <InputSelect
                  label="Sudah Memebeli Tiket?"
                  name="tiket"
                  options={tiketOptions}
                  control={control}
                  error={errors.tiket}
                  required
                />

                <InputSelect
                  label="Transportasi Perjalanan"
                  name="transportasi"
                  control={control}
                  options={transportOptions}
                  error={errors.transportasi}
                  required
                />

                {/* ====================== */}
                {/* TRANSPORTASI PESAWAT */}
                {/* ====================== */}
                {transportasi === 'PESAWAT' && (
                  <>
                    <InputText
                      label="Maskapai Berangkat"
                      name="maskapai_berangkat"
                      register={register}
                      error={errors.maskapai_berangkat}
                      required
                    />
                    <InputJam
                      label="Jam Berangkat"
                      name="jam_berangkat_pesawat"
                      register={register}
                      error={errors.jam_berangkat_pesawat}
                      required
                    />
                    <InputText
                      label="Bandara Berangkat"
                      name="bandara_berangkat"
                      register={register}
                      error={errors.bandara_berangkat}
                      required
                    />

                    <InputText
                      label="Maskapai Pulang"
                      name="maskapai_pulang"
                      register={register}
                      error={errors.maskapai_pulang}
                      required
                    />
                    <InputJam
                      label="Jam Pulang"
                      name="jam_pulang_pesawat"
                      register={register}
                      error={errors.jam_pulang_pesawat}
                      required
                    />
                    <InputText
                      label="Bandara Pulang"
                      name="bandara_pulang"
                      register={register}
                      error={errors.bandara_pulang}
                      required
                    />
                  </>
                )}

                {/* ====================== */}
                {/* TRANSPORTASI KERETA   */}
                {/* ====================== */}
                {transportasi === 'KERETA' && (
                  <>
                    <InputJam
                      label="Jam Berangkat"
                      name="jam_berangkat_kereta"
                      register={register}
                      error={errors.jam_berangkat_kereta}
                      required
                    />
                    <InputText
                      label="Stasiun Keberangkatan"
                      name="stasiun_berangkat"
                      register={register}
                      error={errors.stasiun_berangkat}
                      required
                    />
                    <InputJam
                      label="Jam Pulang"
                      name="jam_pulang_kereta"
                      register={register}
                      error={errors.jam_pulang_kereta}
                      required
                    />
                    <InputText
                      label="Stasiun Kepulangan"
                      name="stasiun_pulang"
                      register={register}
                      error={errors.stasiun_pulang}
                      required
                    />
                  </>
                )}
              </>
            )}

            {/* ====================== */}
            {/* SIGNATURE (MUNCUL SELALU) */}
            {/* ====================== */}

            <Controller
              name="signature"
              control={control}
              rules={{ required: 'Silahkan bubuhkan tanda tangan' }}
              render={({ field }) => (
                <InputSignature
                  label="Tanda Tangan"
                  value={field.value}
                  onChange={field.onChange}
                  error={errors.signature}
                />
              )}
            />

            <p className="text-gray-600 text-sm">
              Silahkan bubuhkan tanda tangan
            </p>

            {msg && (
              <p className="text-center font-bold text-green-600">{msg}</p>
            )}

            <button
              disabled={loading}
              className={`${loading ?  'bg-gray-500' : 'bg-blue-600'} text-white w-full py-3 rounded-lg font-bold`}>
              {loading ? 'Mengirim...' : 'Submit'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default PageLogin;
